type FeedbackVisibility = {
  hasWrittenFeedback?: boolean | null;
  gradesReleased?: boolean | null;
  correctnessVisible?: boolean | null;
};

/**
 * Whether a student may actually read their teacher's written feedback on this assignment.
 *
 * `hasWrittenFeedback` alone is not the answer, and the schema says so: it is "deliberately NOT
 * gated on release or correct-answer visibility — compose with grades_released and
 * correctness_visible when filtering student-facing views". Showing an indicator off the bare
 * field both promises feedback the student cannot open and discloses that their teacher wrote
 * some before release.
 *
 * Deliberately excludes `studentHasSeenEvaluation`: this marks readable feedback, not unread
 * feedback, so the indicator survives the student reading it.
 */
export function canReadTeacherFeedback(assignment: FeedbackVisibility): boolean {
  return Boolean(
    assignment.hasWrittenFeedback && assignment.gradesReleased && assignment.correctnessVisible
  );
}
